import { render, staticRenderFns } from "./DiscordIcon.vue?vue&type=template&id=2637b722&"
import script from "./DiscordIcon.vue?vue&type=script&lang=js&"
export * from "./DiscordIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports